var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',[_c('v-spacer'),_c('div',[_vm._v(" Propulsé par "),_c('v-btn',{staticClass:"pa-0",attrs:{"link":"","href":"https://ca.eudonet.com/","elevation":"0"}},[_vm._v("Eudonet")]),_vm._v(" © ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }